// @generated by protoc-gen-connect-es v1.1.3 with parameter "target=ts"
// @generated from file gdx/activity/v1/activity_api.proto (package gdx.activity.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { GetActivityStatusRequest, GetActivityStatusResponse, ListActivitiesRequest, ListActivitiesResponse, MakeActivitiesReadRequest, MakeActivitiesReadResponse } from "./activity_api_pb.js";
import { MethodKind } from "@bufbuild/protobuf";

/**
 * Activity service.
 *
 * @generated from service gdx.activity.v1.ActivityAPI
 */
export const ActivityAPI = {
  typeName: "gdx.activity.v1.ActivityAPI",
  methods: {
    /**
     * List all user activity.
     *
     * @generated from rpc gdx.activity.v1.ActivityAPI.ListActivities
     */
    listActivities: {
      name: "ListActivities",
      I: ListActivitiesRequest,
      O: ListActivitiesResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Makes all incoming activity as read.
     *
     * @generated from rpc gdx.activity.v1.ActivityAPI.MakeActivitiesRead
     */
    makeActivitiesRead: {
      name: "MakeActivitiesRead",
      I: MakeActivitiesReadRequest,
      O: MakeActivitiesReadResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Returns current activity status for authorized user.
     *
     * @generated from rpc gdx.activity.v1.ActivityAPI.GetActivityStatus
     */
    getActivityStatus: {
      name: "GetActivityStatus",
      I: GetActivityStatusRequest,
      O: GetActivityStatusResponse,
      kind: MethodKind.Unary,
    },
  }
} as const;

